export enum UserRole {
  ITAdmin = 3,
  AoResponsibleOfficer = 18,
  AORegulationTeam = 26,
  OfqualSocAdmin = 35,
  CCEASocAdmin = 36,
  AoChair = 19,
}

export const SocRoles = [
  UserRole.AoResponsibleOfficer,
  UserRole.AORegulationTeam,
  UserRole.CCEASocAdmin,
  UserRole.OfqualSocAdmin,
  UserRole.ITAdmin
];